<ng-container>
    <div class="left">
        <h3 class="form-header" mat-dialog-title i18n="@@4776616040177356216" t="4776616040177356216"
            >Manage Default Characteristics/Deliverables</h3
        >
    </div>
    <mat-dialog-content>
        <mat-card>
            <div [formGroup]="manageGroup" class="grid">
                <div fxLayout="row" fxLayoutGap="10px">
                    <!-- Category -->
                    <div fxFlex="965px">
                        <div fxFlex="35">
                            <tsl-form-field fxFlex="90">
                                <tsl-label
                                    for="category"
                                    i18n="@@0fbc0bbce830bd50141fac696299f15bed5563c8"
                                    t="0fbc0bbce830bd50141fac696299f15bed5563c8"
                                    >Category</tsl-label
                                >
                                <tsl-select
                                    id="category"
                                    required
                                    fullWidth
                                    formControlName="toolCategory"
                                    (selectionChange)="onChangeCategory($event)"
                                >
                                    <tsl-option *ngFor="let cat of filterCategories" [value]="cat.id">{{
                                        translate.get(cat.category)
                                    }}</tsl-option>
                                </tsl-select>
                                <tsl-error *ngIf="toolCategory.invalid" i18n="@@Required" t="Required"
                                    >Required</tsl-error
                                >
                            </tsl-form-field>
                        </div>
                        <!-- Subcategory -->
                        <div fxFlex="45">
                            <tsl-form-field fxFlex="90">
                                <tsl-label
                                    for="subcategory"
                                    i18n="@@301aa836dcab43dc07491c377b37e32132225c19"
                                    t="301aa836dcab43dc07491c377b37e32132225c19"
                                    >Sub-Category</tsl-label
                                >
                                <tsl-select
                                    id="subcategory"
                                    required
                                    fullWidth
                                    formControlName="toolSubcategory"
                                    (selectionChange)="onChangeSubcategory($event)"
                                    multiple
                                >
                                    <tsl-option *ngFor="let sub of filterSubcategories" [value]="sub.id">{{
                                        translate.get(sub.subcategory)
                                    }}</tsl-option>
                                </tsl-select>
                                <tsl-error *ngIf="toolSubcategory.invalid" i18n="@@Required" t="Required"
                                    >Required</tsl-error>
                            </tsl-form-field>
                        </div>
                        <!-- Type -->
                        <div fxFlex="20">
                            <tsl-form-field fxFlex="100">
                                <tsl-label for="type" i18n="@@Type" t="Type">Type</tsl-label>
                                <tsl-select
                                    id="type"
                                    required
                                    fullWidth
                                    formControlName="defaultType"
                                    (selectionChange)="onChangeDefaultType($event)"
                                >
                                    <tsl-option *ngFor="let type of defaultTypes" [value]="type">
                                        {{ translate.get(type) }}</tsl-option
                                    >
                                </tsl-select>
                                <tsl-error *ngIf="defaultType.invalid" i18n="@@Required" t="Required"
                                    >Required
                                </tsl-error>
                            </tsl-form-field>
                        </div>
                    </div>
                </div>

                <br />
                <div class="row" *ngIf="isParam">
                    <!-- Parameter -->
                    <div class="column" fxFlex="80%">
                        <!--change these values so that the window is bigger-->
                        <tsl-form-field fxFlex="50%">
                            <tsl-label
                                i18n="@@c27f1609332ee8b368f8061a22ff9e9aa3f6fc8b"
                                t="c27f1609332ee8b368f8061a22ff9e9aa3f6fc8b"
                                >Characteristic</tsl-label
                            >
                            <mat-chip-list #parameterChipList>
                                <input
                                    tPlaceholder="441496379265396129" i18n-placeholder="@@441496379265396129"
                                    placeholder="Add new Characteristic and press enter..."
                                    tslInput
                                    formControlName="parameter"
                                    [matAutocomplete]="auto"
                                    [matChipInputFor]="parameterChipList"
                                    [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
                                    (matChipInputTokenEnd)="addParameter($event)"
                                />
                                <mat-chip
                                    style="background-color: #cecece;"
                                    *ngFor="let param of parameterList"
                                    [selectable]="selectable"
                                    [removable]="removable"
                                    (removed)="onRemoveParameter(param)"
                                >
                                    {{ translate.get(param.type) }}
                                    <tsl-icon matChipRemove *ngIf="removable && (isOwner || param.id === 0)"
                                        >cancel
                                    </tsl-icon>
                                </mat-chip>
                            </mat-chip-list>
                            <mat-autocomplete
                                #auto="matAutocomplete"
                                (optionSelected)="onSelectFromSearchList($event.option, 'parameter')"
                            >
                                <mat-option *ngFor="let item of searchParameterList" [value]="item.type">
                                    {{ translate.get(item.type) }}
                                </mat-option>
                            </mat-autocomplete>
                        </tsl-form-field>
                    </div>
                </div>
                <div class="row" *ngIf="isDeliverable">
                    <!-- Event Types -->
                    <div class="column" fxFlex="20%">
                        <tsl-form-field fxFlex="90%">
                            <tsl-label
                                for="event"
                                i18n="@@a20835f355331a7398ce79b54cff3c57e96b3c75"
                                t="a20835f355331a7398ce79b54cff3c57e96b3c75"
                                >Event</tsl-label
                            >
                            <tsl-select
                                id="event"
                                fullWidth
                                (selectionChange)="onChangeEventType($event)"
                                formControlName="eventType"
                            >
                                <tsl-option *ngFor="let type of eventTypes" [value]="type">
                                    {{ translate.get(type) }}</tsl-option
                                >
                            </tsl-select>
                        </tsl-form-field>
                    </div>
                    <!-- Deliverables -->
                    <div class="column" fxFlex="60%">
                        <tsl-form-field fxFlex="90%">
                            <tsl-label i18n="@@Deliverable" t="Deliverable">Deliverable</tsl-label>
                            <mat-chip-list #deliverableChipList>
                                <input
                                    tPlaceholder="3888958944469226991" i18n-placeholder="@@3888958944469226991"
                                    placeholder="Add new deliverable and press enter..."
                                    tslInput
                                    [disabled]="!eventType.value"
                                    [matAutocomplete]="auto"
                                    [matChipInputFor]="deliverableChipList"
                                    [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
                                    formControlName="deliverable"
                                    (matChipInputTokenEnd)="addDeliverable($event)"
                                />
                                <mat-chip
                                    style="background-color: #cecece;"
                                    *ngFor="let del of deliverableList"
                                    [selectable]="selectable"
                                    [removable]="removable"
                                    (removed)="onRemoveDeliverable(del)"
                                >
                                    {{ translate.get(del.deliverable) }}
                                    <tsl-icon matChipRemove *ngIf="removable && (isOwner || del.id === 0)"
                                        >cancel
                                    </tsl-icon>
                                </mat-chip>
                            </mat-chip-list>
                            <mat-autocomplete
                                #auto="matAutocomplete"
                                (optionSelected)="onSelectFromSearchList($event.option, 'deliverable')"
                            >
                                <mat-option *ngFor="let item of searchDeliverableList" [value]="item.deliverable">
                                    {{ translate.get(item.deliverable) }}
                                </mat-option>
                            </mat-autocomplete>
                        </tsl-form-field>
                    </div>
                </div>
                <!-- Action Buttons -->
                <div class="left">
                    <button
                        *ngIf="!isOwner"
                        tsl-button
                        size="small"
                        color="blue"
                        [disabled]="manageGroup.invalid"
                        (click)="proposeAsDefault(true, 'Submitted')"
                        i18n="@@30bf1ecd0572a1be361c9e193a53a61482903179"
                        t="30bf1ecd0572a1be361c9e193a53a61482903179"
                        >Propose as default</button
                    >
                    <button
                        *ngIf="isOwner"
                        tsl-button
                        size="small"
                        color="blue"
                        [disabled]="manageGroup.invalid"
                        (click)="setAsDefault(true, 'Approved')"
                        i18n="@@c210b89089ca8e2f0ef9a829c17f4a38f6945982"
                        t="c210b89089ca8e2f0ef9a829c17f4a38f6945982"
                        >Set as default</button
                    >
                </div>
            </div>
            <br />
            <mat-accordion *ngIf="!isOwner">
                <mat-expansion-panel expanded="false">
                    <mat-expansion-panel-header>
                        <mat-panel-title>
                            <h3
                                class="section-title"
                                i18n="@@67c679e2d14206c5a643d36468c5543d6393b4ed"
                                t="67c679e2d14206c5a643d36468c5543d6393b4ed"
                                >Proposed Defaults</h3
                            >
                        </mat-panel-title>
                    </mat-expansion-panel-header>
                    <ng-container>
                        <!-- grid start -->
                        <table tsl-table [dataSource]="proposedDefaults">
                            <!-- Subcategory Column -->
                            <ng-container tslColumnDef="subcategory">
                                <th
                                    tsl-header-cell
                                    *tslHeaderCellDef
                                    i18n="@@301aa836dcab43dc07491c377b37e32132225c19"
                                    t="301aa836dcab43dc07491c377b37e32132225c19"
                                    >Sub-Category</th
                                >
                                <td tsl-cell *tslCellDef="let row">{{ translate.get(row.subCategory) }} </td>
                            </ng-container>

                            <!-- Type Column -->
                            <ng-container tslColumnDef="type">
                                <th tsl-header-cell *tslHeaderCellDef i18n="@@Type" t="Type">Type</th>
                                <td tsl-cell *tslCellDef="let row">{{ translate.get(row.type) }}</td>
                            </ng-container>

                            <!-- EventType Column -->
                            <ng-container tslColumnDef="eventType">
                                <th
                                    tsl-header-cell
                                    *tslHeaderCellDef
                                    i18n="@@cd550b7d464c8e32e729980af58ea8e466faeb21"
                                    t="cd550b7d464c8e32e729980af58ea8e466faeb21"
                                    >Event Type</th
                                >
                                <td tsl-cell *tslCellDef="let row">{{ translate.get(row.eventType) }} </td>
                            </ng-container>

                            <!-- Description Column -->
                            <ng-container tslColumnDef="description">
                                <th tsl-header-cell *tslHeaderCellDef i18n="@@Description" t="Description"
                                    >Description</th
                                >
                                <td tsl-cell *tslCellDef="let row">{{ translate.get(row.name) }} </td>
                            </ng-container>

                            <tr tsl-header-row *tslHeaderRowDef="displayedProposedColumns"></tr>
                            <tr tsl-row *tslRowDef="let row; columns: displayedProposedColumns"></tr>
                        </table>

                        <!-- grid pagination -->
                        <tsl-pagination
                            showFirstLastButtons
                            [pageSizeOptions]="pageSizeOptions"
                            [total]="length"
                            [pageSize]="pize"
                            [pageIndex]="pIndex"
                            (pageChange)="onProposedDefaultsPageChange($event)"
                            [itemsPerPageLabel]="translate.get('ItemsPerPage')"
                        >
                        </tsl-pagination>
                    </ng-container>
                </mat-expansion-panel>
            </mat-accordion>
            <br />
            <mat-accordion>
                <mat-expansion-panel expanded="true">
                    <mat-expansion-panel-header>
                        <mat-panel-title>
                            <h3
                                class="section-title"
                                i18n="@@9aed60ac9faeaf0ddf76cc23a2eb63ce3449c43b"
                                t="9aed60ac9faeaf0ddf76cc23a2eb63ce3449c43b"
                                >Defaults</h3
                            >
                        </mat-panel-title>
                    </mat-expansion-panel-header>
                    <ng-container>
                        <!-- grid start -->
                        <table tsl-table [dataSource]="defaultDataSource">
                            <!-- Subcategory Column -->
                            <ng-container tslColumnDef="subcategory">
                                <th
                                    tsl-header-cell
                                    *tslHeaderCellDef
                                    i18n="@@301aa836dcab43dc07491c377b37e32132225c19"
                                    t="301aa836dcab43dc07491c377b37e32132225c19"
                                    >Sub-Category</th
                                >
                                <td tsl-cell *tslCellDef="let row">{{ translate.get(row.subCategory) }} </td>
                            </ng-container>

                            <!-- Type Column -->
                            <ng-container tslColumnDef="type">
                                <th tsl-header-cell *tslHeaderCellDef i18n="@@Type" t="Type">Type</th>
                                <td tsl-cell *tslCellDef="let row">{{ translate.get(row.type) }}</td>
                            </ng-container>

                            <!-- EventType Column -->
                            <ng-container tslColumnDef="eventType">
                                <th
                                    tsl-header-cell
                                    *tslHeaderCellDef
                                    i18n="@@cd550b7d464c8e32e729980af58ea8e466faeb21"
                                    t="cd550b7d464c8e32e729980af58ea8e466faeb21"
                                    >Event Type</th
                                >
                                <td tsl-cell *tslCellDef="let row">{{ translate.get(row.eventType) }} </td>
                            </ng-container>

                            <!-- Description Column -->
                            <ng-container tslColumnDef="description">
                                <th tsl-header-cell *tslHeaderCellDef i18n="@@Description" t="Description"
                                    >Description</th
                                >
                                <td tsl-cell *tslCellDef="let row">{{ row.name }} </td>
                            </ng-container>

                            <!-- Action -->
                            <ng-container tslColumnDef="delete">
                                <th
                                    tsl-header-cell
                                    *tslHeaderCellDef
                                    style="width:3%;top:50px!important"
                                    i18n="@@Delete"
                                    t="Delete"
                                    >Delete</th
                                >
                                <td tsl-cell *tslCellDef="let row">
                                    <button
                                        tsl-icon-button
                                        *ngIf="!row.type === 'Deliverable' && isOwner"
                                        (click)="onDelete(row)"
                                    >
                                        <tsl-icon>delete</tsl-icon>
                                    </button>
                                </td>
                            </ng-container>

                            <tr tsl-header-row *tslHeaderRowDef="displayedDefaultsColumns"></tr>
                            <tr tsl-row *tslRowDef="let row; columns: displayedDefaultsColumns"></tr>
                        </table>

                        <!-- grid pagination -->
                        <tsl-pagination
                            showFirstLastButtons
                            [pageSizeOptions]="pageSizeOptions"
                            [total]="total"
                            [pageSize]="pageSize"
                            [pageIndex]="pageIndex"
                            (pageChange)="onDefaultsPageChange($event)"
                            [itemsPerPageLabel]="translate.get('ItemsPerPage')"
                        >
                        </tsl-pagination>
                    </ng-container>
                </mat-expansion-panel>
            </mat-accordion>
        </mat-card>
        <br />
        <mat-accordion *ngIf="isOwner">
            <mat-expansion-panel expanded="true">
                <mat-expansion-panel-header>
                    <mat-panel-title>
                        <h3
                            class="section-title"
                            i18n="@@a1e164bc734a2ad68718579de1a28c0227467d68"
                            t="a1e164bc734a2ad68718579de1a28c0227467d68"
                            >Pending for Approval
                        </h3>
                    </mat-panel-title>
                </mat-expansion-panel-header>
                <app-defaults-approval-grid [supplierCode]="dialogData.supplierCode"></app-defaults-approval-grid>
            </mat-expansion-panel>
        </mat-accordion>
    </mat-dialog-content>
    <!-- Action Buttons -->
    <div class="left" style="padding-top: 20px;">
        <button tsl-button size="small" color="black" outline (click)="onClose()" i18n="@@Close" t="Close"
            >Close</button
        >
    </div>
</ng-container>
